export function nextStatusFilterValue(
  activeFilterValue: string,
  clickedFilterValue: string,
): string {
  if (clickedFilterValue !== '' && activeFilterValue === clickedFilterValue) {
    return '';
  }
  return clickedFilterValue;
}
